import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, AfterViewInit, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { DatePipe } from '@angular/common';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ItineraryService} from '../../shared/itinerary.service';
import { FidelityService } from '../../fidelity/fidelity.service';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModalAlertComponent } from '../../shared/material-modal-alert/material-modal-alert.component';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { selectPermissions } from 'app/core/profiles/profiles.selectors';
import { DynamicFontSizePipe } from 'app/shared/dynamic-font-size.pipe';
import CssFilterConverter from 'css-filter-converter';
import * as moment from 'moment';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-price-itinerary',
  templateUrl: './price-itinerary.component.html',
  styleUrls: ['./price-itinerary.component.scss'],
  providers: [DatePipe, DynamicFontSizePipe]
})
export class PriceItineraryComponent implements OnInit, AfterViewInit {

  @Input() itinerary: any;
  @Input() screen: any;
  @Input() partialReserve: boolean;
  @Input() modifications: boolean;
  @Input() showPartialContainer: boolean;
  @Input() netPriceBookingFreeTax: number;
  @Input() netPriceBooking: number;
  @Input() totalTaxNightsPriceTotal: number;
  @Input() taxSum: number = 0;
  @Input() onSync: boolean = false;
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() getClientsSettingAppBooking: any;
  @Input() buttonTextActive: string;
  @Output() updateEmitter = new EventEmitter<any>();
  @Output() netPrice      = new EventEmitter<any>();
  @Output() globalFeeUnavaibleWithAmount = new EventEmitter<any>();
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
  @ViewChildren('icons_two', { read: ElementRef }) icons_two: QueryList<ElementRef>;
  styleSidebar: any;
  modalRef: BsModalRef;
  element: HTMLElement;
  element_: HTMLElement;
  _emailAgency: any;
  @Input() fromReserve: boolean;
  fontSizeAdjustments = { 6: -1, 9: -3 };
    filterColorIcon: any;
    priceToPayAgency: any;

  fee: any = 0;
  totalPrice: number = 0;
  feePercentage: number = 0;
  pointCategory: any= 0;
  totalPriceByReserved: any= 0;
  actualItinerary: any;
  ///  totalPriceNetByReserved: any= 0;
  priceToPay: number = 0;
  blickoinsPartial: number = 0;
  reserved: boolean = false;

  totalPriceNotFeeByReserved: any;
  totalPriceYesFeeByReserved: any;

private dateFormatCache = new Map<string | any, string>();
  button =  <HTMLInputElement>document.getElementById('buttonSync');
  sec: boolean = false;
  timeLeft: any = '';
  currentDate: Date = new Date();
  loadPrice: boolean = false;

  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};
  getOrigin:string = '';

  public bookingURL: string;
  public currencyItinerary: string;
  ngAfterViewInit() {
    const tooltipTriggerList = this.elementRef.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]');
   // const tooltipList = tooltipTriggerList.map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  }

  config = {
    backdrop: 'static',  // Evita el cierre al hacer clic fuera del modal
    keyboard: false,     // Desactiva el cierre con la tecla Escape
    class: 'modal-dialog-centered'
  };
  itinerary$: Observable<any[]>;

  constructor(
              public itineraryService: ItineraryService,
              private datePipe: DatePipe,
              private modalService: BsModalService,
              public fidelityService: FidelityService,
              public userService: UserService,
              public dialog: MatDialog,
              private elementRef: ElementRef,
              private store: Store<AppState>,
              private notificationService: NotificationService

            ) {
              this.bookingURL = setting.apiBookingUrl;
              }

  ngOnInit() {
    this.loadPrice = true;
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.applyImageFilter();
    this.getOrigin = localStorage.getItem('origin');

    this.permissions$ = this.store.select(selectPermissions);
    this.permissions$.subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });

    this.userService.totalPriceNotFeeByReserved =  0;
    this.userService.totalPriceYesFeeByReserved =  0;
    this.userService.totalPriceNotFee = 0;
    this.userService.totalPriceYesFee = 0;
    this.userService.priceRightFee = 0;

    this.userService.priceRightFeePercentage = 0;
    this.userService.totalBlickoins = 0;
    this.itineraryService.parcialBlickoins = 0;

    this.userService.totalPriceNotFeeByReservedAgency =  0;
    this.userService.totalPriceYesFeeByReservedAgency =  0;
    this.userService.totalPriceNotFeeAgency = 0;
    this.userService.totalPriceYesFeeAgency = 0;
    // this.userService.priceRightFeeAgency = 0;

    if (this.userService.itineraryActive[0] !== undefined ) {
      this.actualItinerary = this.userService.itineraryActive[0];
    } else {
      this.actualItinerary = this.itinerary;
    }

    this.userService.totalPriceNotFeeByReserved = this.userService.totalPriceNotFeeByReserved;
    this.userService.totalPriceYesFeeByReserved = this.userService.totalPriceYesFeeByReserved;
    this.userService.priceRightFeeAgency  = this.userService.priceRightFeeAgency;
    this.userService.totalPriceNotFee = this.actualItinerary.totalNetPriceBooking > 0 ? this.actualItinerary.totalNetPriceBooking : this.actualItinerary.netPriceBookingFreeTax;
    this.userService.totalPriceNotFee = this.actualItinerary.totalNetPriceBooking > 0 ? this.actualItinerary.totalNetPriceBooking : this.actualItinerary.netPriceBookingFreeTax;

    if(this.userService.totalPriceYesFee > 0) {
      this.userService.totalPriceYesFee = this.userService.totalPriceYesFee
    }
    if(this.userService.totalPriceYesFee === 0) {
      if(this.actualItinerary.totalFee > 0 && this.actualItinerary.totalNetPriceAgent) {
        this.userService.activeGlobalFee = true;
        this.userService.totalPriceYesFee = this.actualItinerary.totalNetPriceAgent;
        // priceRightFeePercentage
            this.userService.priceRightFee = this.actualItinerary.totalFee;
            this.userService.priceRightFeePercentage = this.actualItinerary.percentageFee;
            this.userService.globalFee = this.userService.priceRightFeePercentage;
      }
    }


    // this.userService.totalPriceYesFee = this.userService.totalPriceYesFee ? this.userService.totalPriceYesFee : this.actualItinerary.totalNetPriceBooking;
    this.itineraryService.parcialBlickoins = this.itineraryService.parcialBlickoins;
    this.currencyItinerary = this.actualItinerary.currency;

    this.itinerary$ = this.itineraryService.getItinerary$();
    this.itinerary$.subscribe((data:any) => {

    const items = data && data.length > 0 ? data[0].items : [];

    if(items.length > 0) {
      this.userService.totalPriceNotFeeAgency = this.sumPropertyValues(items, 'netPriceBooking');
      this.userService.totalPriceYesFeeAgency = this.sumPropertyValues(items, 'netPriceAgent');
      // this.userService.priceRightFeeAgency = this.sumPropertyValues(items, 'fee');
      this.searchPriceToReserve();
        if(!this.onSync) {
          this.userService.priceRightFee = data && data.length > 0 && data[0]?.totalFee ? data[0].totalFee : 0;
          if(this.userService.priceRightFee > 0) {
             this.userService.totalPriceYesFee = data && data.length > 0 && data[0].totalNetPriceBooking && data[0].totalNetPriceAgent > 0 ? data[0].totalNetPriceAgent : data[0].totalNetPriceBooking;
          } else {
            this.userService.totalPriceYesFee = data && data.length > 0 && data[0].totalNetPriceBooking && data[0].totalNetPriceBooking > 0 ? data[0].totalNetPriceBooking : data[0].totalNetPriceBookingFreeTax;
          }
        }


    }
      this.loadPrice = false;
    });
    this.setValueTotals();

    if(this.fromReserve) {

    }

  }

    sumPropertyValues(data: any[], propertyName: string): number {
    let totalValue = 0;
    data.reduce((total, item, index) => {
      const itemParse = item;
      if(item.status_id !== 4 && item.status_id !== 5) {
        // Asegurarse de que el objeto tenga la propiedad deseada
        if (item[propertyName]) {

            const itemBaseCurrency = this.currencies.find(c => c.code === item.currency);
            const itemBasePrice = item[propertyName] / itemBaseCurrency.rate;
            totalValue += itemParse?.converted_amounts ? itemParse?.converted_amounts[propertyName] : (itemBasePrice * this.currencyAgency.rate);
          }
        }
        return total;
    }, 0);

    totalValue = totalValue ;

    return totalValue;
  }

  // Función helper para truncar decimales (similar a la de backend)
truncateFloat(value: number, decimals: number): number {
  return parseFloat(value.toFixed(decimals));
}

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      // Utiliza el nombre del permiso como clave
      map[permission.name] = permission;
    });
    return map;
  }



   blockButton(time: any) {
      let   countdown = 10;
      const interval = setInterval(() => {
        countdown = --countdown <= 0 ? 10 : countdown;
        this.timeLeft =  countdown;
        this.sec = true;
        if (countdown == 1) {
          this.sec = false;
          this.timeLeft = '';
          clearInterval(interval);
        }
      }, 1000);
  }

  hasAvailableStatus(): boolean {
    return this.itinerary.items.some(c => {
      return c.status_id === 1;
    });
  }

  hasDisabledAlertMessage(): boolean {
    return this.itinerary.items.some(c => c.syncProduct?.alert === true);
  }

  hasAvailableStatusLiquidation(): boolean {
    return this.itinerary.status_id === 5;
  }

  sendMail() {
    this.element_ = document.getElementById('items-' + this.itinerary.id) as HTMLElement;
      if (this.element_) {
          this.element = document.getElementById('contentPDF-' + this.itinerary.id) as HTMLElement;
          this.itineraryService.postSendEmail(this.itinerary, this.element.innerHTML).subscribe(
          (response:any) => {
            if (response['send'] === 'true') {
                this.modalRef.hide();
            } else {
                this.modalRef.hide();
            }
          },
        );
      }
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }
  closeModal(): void {
    this.modalRef.hide();
  }

  getUpdateDate() {
    return this.datePipe.transform(new Date(), 'MMM dd, yyyy');
  }
  getModificationDate(){
    return this.datePipe.transform(this.itinerary.updated_at, 'MMM dd, yyyy');
  }

  updateItinerary(){
    this.onSync = true;
    this.blockButton(10000);
    this.updateEmitter.emit();
  }


  getComission() {
    let comission = 0;
    if (this.itinerary.items.length > 0) {
        this.itinerary.items.forEach(item => {
        comission += item.optionComissionValue ? item.optionComissionValue : 0;
      });
    }
    return comission;
  }

  globalFeeClick(event: any){

        if(this.itinerary.items.some(c => c.status_id === 1)) {
  const isChecked = event.target.checked;

    if(this.userService.priceRightFeePercentage > 0 && !isChecked) {
      const initialState: ModalOptions = {
              initialState: {
                data: {message: 'Si continúa el fee global volvera a cero'}
              }
            }

      const modalOptions = Object.assign({}, initialState, this.config);
      this.modalRef = this.modalService.show(MaterialModalConfirmComponent,  modalOptions);

        this.modalRef.content.confirmResult.subscribe((result: boolean) => {
          if(result) {
            this.userService.priceRightFeePercentage = 0;
            this.userService.globalFee = 0;
            this.userService.activeGlobalFee = false;
            this.userService.itinerayDetailFee.percentageFee = 0;
            this.userService.itinerayDetailFee.totalFee = 0;
            this.userService.itinerayDetailFee.totalPriceAgent = 0;
            this.userService.sendGlobalFee$(this.userService.globalFee);
            // this.globalFeeUnavaibleWithAmount.emit();
          } else {
            this.userService.activeGlobalFee = true;
          }
        });
    }

    this.userService.globalFee = this.userService.priceRightFeePercentage;
        } else {
          this.notificationService.info('No puede activar/desactivar el fee global');
          return
        }


  }

  verifyGlobalFee(){
    if(this.userService.globalFee >0){
      this.userService.activeGlobalFee = true;
      this.userService.itinerayDetailFee.percentageFee = 0.0;
      this.userService.itinerayDetailFee.totalFee = 0.0;
      this.userService.itinerayDetailFee.totalPriceAgent = 0.0;
      this.userService.sendGlobalFee$(this.userService.globalFee);
    }
  }

  changeGlobalFee(){




    if (this.userService.globalFee == "") {

      var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
        width: '350px',
        data: 'Debe agregar un valor',
        disableClose: true
      });
      this.userService.globalFee = 0;
    }else{
      this.loadPrice = true;
      if(this.userService.globalFee < 0){
        this.userService.globalFee = 0;
      }

      this.userService.sendGlobalFee$(this.userService.globalFee);
    }
  }

  validateProductsToPay(){

    this.reserved = this.itinerary.items.find(element => element.status_id == 1);
    // console.log("existe items con status id 2 ", reserved);
    if(this.reserved){
      let filter = this.itinerary.items.filter(element => element.status_id != 2 && element.status_id != 4 );
      // console.log("existe items con status id 2 ", filter);

      if(filter.length > 0){
        let i =0;
        filter.forEach(element => {
          // eslint-disable-next-line max-len
          if (element.isPendigApprovePay===false && element.isPaidAgency===false && element.isPaidProvider===false && element.isBilled===false){
            i++;
          }
        });

        if(i > 0){
          return true;
        }else{
          return false;
        }
      }
    }

  }

searchPriceToReserve() {
  if (!this.itinerary?.items?.length) return;

  // 1. Filtrar elementos con status_id diferente de 2 y 5
  const validItems = this.itinerary.items.filter(
    element => element.status_id != 2 && element.status_id != 5
  );

  if (validItems.length === 0) {
    this.priceToPay = 0;
    this.priceToPayAgency = 0;
    return;
  }

  let totalInUSD = 0;
  let totalInAgencyCurrency = 0;

  // Obtener tasas de conversión necesarias
  const usdCurrency = this.currencies?.find(c => c.code === 'USD');
  const agencyCurrency = this.currencyAgency;

  if (!usdCurrency || !agencyCurrency) {
    console.error('Faltan configuraciones de moneda');
    return;
  }

  const usdRate = parseFloat(usdCurrency.rate); // Tasa de USD
  const agencyRate = parseFloat(agencyCurrency.rate); // Tasa de la agencia

  // 2. Calcular totales
  validItems.forEach(element => {
    // Convertir a USD primero
    const itemCurrency = this.currencies.find(c => c.code === element.currency);
    const itemRate = itemCurrency ? parseFloat(itemCurrency.rate) : 1;

    const priceInUSD = parseFloat(element.netPriceBookingFreeTax) / itemRate;

    totalInUSD += priceInUSD;

    // Convertir a moneda de la agencia
    totalInAgencyCurrency += priceInUSD * agencyRate;
  });

  // 3. Asignar resultados
  this.priceToPay = parseFloat(totalInUSD.toFixed(2)); // Precio en USD
  this.priceToPayAgency = parseFloat(totalInAgencyCurrency.toFixed(2)); // Precio en moneda de agencia
}

  setValueTotals(){
    if(this.itinerary && this.itinerary.items) {
      let result = this.itinerary.items.every(element => element.status_id == 5);
      if(result){
        this.userService.totalPriceNotFee = 0;
        this.userService.totalPriceYesFee = 0;
      }

    }
  }

  downloadLiquidation(id: number): void {


    if(this.hasAvailableStatusLiquidation()) {

          let message: string = '';

          message = 'No puede descargar la liquidación, ya que este file se encuentra cancelado.';

        this.notificationService.info(message);
        return;
    }


        this.itineraryService.liquidationDownload(id, this.getClientsSettingAppBooking.id);

  }

   applyImageFilter() {
        const color = this.styleSidebar?.color;
        const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

        //Extraemos el literal en String de la conversión
        const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

        // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
        const colorRegex = /color\((.*)\)/;
        const colorMatch = tempFilterStr.match(colorRegex);
        const colorFilter = colorMatch ? colorMatch[1] : "";

        this.filterColorIcon = colorFilter;
        // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
        setTimeout(() => {
          this.icons.forEach(icon => {
            icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 24px;`);
          });

           this.icons_two.forEach(icon => {
            icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 14px;`);
          });
         // console.log(this.filter);
        }, 100);
      }

      getDateInOut(date: any): string {
        if (!date) return 'Fecha no válida';

        // Primero parsear la fecha con el formato correcto
        const parsedDate = moment(date);

        // Verificar si la fecha es válida
        if (!parsedDate.isValid()) {
          console.error('Fecha inválida:', date);
          return 'Fecha inválida';
        }

        // Formatear la salida
        return parsedDate.locale('es').format('MMM DD, YYYY');
      }

     downloadItineraryQuote(id: number, type: string): void {

      if(this.hasAvailableStatusLiquidation()) {

        let message: string = '';
        if(type === 'quote') {
          message = 'No puede descargar la cotización, ya que este file se encuentra cancelado.';
        } else {
          message = 'No puede descargar el itinerario, ya que este file se encuentra cancelado.';
        }

        this.notificationService.info(message);

        return;
      }


      if(type === 'quote') {
          this.itineraryService.itineraryDownload(id, this.getClientsSettingAppBooking.id, type);
      } else {
        if(this.itinerary.items.some(c => c.status_id === 2)) {
          this.itineraryService.itineraryDownload(id, this.getClientsSettingAppBooking.id, type);
        } else {
           let message: string = '';

            message = 'No puede descargar el itinerario, ya que este file no tiene productos reservados.';

            this.notificationService.info(message);

            return;


        }
      }



      }

}
